module.exports = __webpack_public_path__ + "static/media/logo_transpocred.851be773.svg";